import './Tagline.css';
import React , {Component} from 'react';
import image1 from '../../../images/branding_image_1.jpg';
function Tagline(){
    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <div className='title'>
                        <div className='info'>
                            <h2 className='py-3'>تگ لاین</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row bottom-box pt-5'>
            <div className='col-12 col-md-6'>
                    <img  src={image1}/>
                </div>
                <div className='col-12 col-md-6'>
                    <p>جایی در مسیر مستقیم اما پرفرازونشیب روزمرگی، ناگهان نیازی متفاوت در ذهن انسان جرقه می‌زند؛ نیاز به مواجهه‌ با چیزی و جایی ناشناخته؛ به جایی برای تنهابودن، به رفتنی به‌قصد توسعه‌ کسب‌وکار یا به زمانی برای بودن و تماشای طبیعت.
از میان هزاران مقصد، اقامتگاه و وسیله آمدورفتن، مقصدی برای دورشدن از روزمرگی، جایی برای اقامتی مطلوب و وسیله‌ای برای رسیدن و بازگشتن را انتخاب می‌کنیم و درنهایت، هرکدام آنچه از سفر می‌خواهیم را به‌گونه‌‌ای متفاوت درمی‌یابیم. یکی در تنهایی و دیگری در جمع، یکی در شهری تاریخی و دیگری در کنار تالابی کوچک. ذهن یکی را باریکه‌های نوری که از میان درختان یک جنگل تابیده روشن می‌کند و ذهن دیگری را ستارگان آسمان شبِ کویر.
سفر برای هرکدام از ما به‌شکلی منحصربه‌فرد معنی می‌شود و با سبک‌های متفاوت اما هم‌زمان پیش می‌رود، تا جایی که سرزمینی از تنوع و رنگ و نشانه ساخته شود و آسمانی از علائق و سلائق.
گویی باید پذیرفت که این «زندگی و سفر در کهکشانی از جهان‌های موازیِ متفاوت» است که به هستی معنا می‌بخشد.</p>
                </div>
            </div>
        </div>
    )
}
export default Tagline;